import type { IELDApp } from '../../../../../../data/queries/eld-apps'

interface IELDAppsCacheEntry {
  data: IELDApp[]
  timestamp: number
}

interface IELDAppsCacheKey {
  carrierWorkspaceID: string | null
  currentWorkspaceID: string
  shipmentOwnerWorkspaceID: string
}

const ELD_APPS_CACHE_TTL = 5 * 60 * 1000 // 5 minutes in milliseconds
const eldAppsCache = new Map<string, IELDAppsCacheEntry>()

export const getCacheKey = (key: IELDAppsCacheKey): string => {
  return `${key.carrierWorkspaceID || 'null'}-${key.currentWorkspaceID}-${key.shipmentOwnerWorkspaceID}`
}

export const getCachedELDApps = (key: IELDAppsCacheKey): IELDApp[] | null => {
  const cacheKey = getCacheKey(key)
  const cached = eldAppsCache.get(cacheKey)

  if (!cached) {
    return null
  }

  const now = Date.now()
  const isExpired = now - cached.timestamp > ELD_APPS_CACHE_TTL

  if (isExpired) {
    eldAppsCache.delete(cacheKey)
    return null
  }

  return cached.data
}

export const cacheELDApps = (key: IELDAppsCacheKey, data: IELDApp[]): void => {
  const cacheKey = getCacheKey(key)
  eldAppsCache.set(cacheKey, {
    data,
    timestamp: Date.now()
  })
}

/**
 * Clears the ELD apps cache. Call this when apps are enabled/disabled
 * to ensure the updated list is fetched on next query.
 */
export const clearELDAppsCache = (): void => {
  eldAppsCache.clear()
}

export type { IELDAppsCacheKey }
